import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_296: DocMigration = {
  maxSchemaVersion: "0.0.296",
  description: "elevation notes from static room layout to room.",
  apply(json: any): any {
    const roomEdgeBehaviors: { [id: string]: any } = {};
    let count = 0;
    for (const roomId in json.staticRoomLayouts) {
      const staticRoomLayout = json.staticRoomLayouts[roomId];
      const elevationNotes = staticRoomLayout?.elevationNotes;
      if (!elevationNotes?.length) {
        continue;
      }

      for (const elevationNote of elevationNotes) {
        const id = uid();
        roomEdgeBehaviors[id] = {
          ...elevationNote,
          entityType: "EDGE_BEHAVIOR",
          edgeBehaviorType: "ELEVATION_NOTE",
          sortIndex: count++,
          parentId: roomId,
          id,
        };
      }

      delete staticRoomLayout.elevationNotes;
    }
    json.roomEdgeBehaviors = roomEdgeBehaviors;
    return json;
  },
};

export default migration_0_0_296;
